declare const Stripe;
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { Plan } from "../../models/plan.model";

let PaymentFormComponent = {
    selector: "vcPaymentForm",
    templateUrl:
        "/angular/components/campaign-plan/payment-form.component.html",
    bindings: {
        plan: "=",
        close: "&",
        charge: "=",
        conversionType: "=",
        changeCard: "=",
    },
    controller: class PaymentFormController {
        // * bindings for typescript compiler *
        public plan: Plan;
        public close: any;
        public charge: any;
        public conversionType: any;
        public changeCard: any;
        // ************************************

        public user: User;
        public campaign: Campaign;
        public error: string = "";
        public currentYear: number;
        // public stripe: Stripe;
        public stripe: any;
        public card: any;
        public cardNumber: any;

        private $scope: any;
        private __env: any;

        private userDataProvider: UserDataProvider;
        private subscriptionDataProvider: SubscriptionDataProvider;
        private campaignDataProvider: CampaignDataProvider;

        constructor(
            $scope: any,
            __env: any,
            UserDataProvider: UserDataProvider,
            SubscriptionDataProvider: SubscriptionDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$scope = $scope;
            this.__env = __env;

            this.userDataProvider = UserDataProvider;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.campaignDataProvider = CampaignDataProvider;

            this.user = this.userDataProvider.getActiveUser();
            this.campaign = this.campaignDataProvider.getActiveCampaign();
            this.currentYear = parseInt(
                new Date().getFullYear().toString().substr(-2)
            );

            this.stripe = Stripe(this.__env.stripe_api_key);
        }

        $onInit() {
            if (!angular.isDefined(this.plan)) {
                this.plan = new Plan({ loading: false });
            } else {
                this.plan.loading = false;
            }

            this.card = {
                brand: "unknown",
                holder_name: "",
                intent: this.plan.intent,
            };

            let elements = this.stripe.elements();

            const elementClasses = {
                focus: "focused",
                empty: "empty",
                invalid: "invalid",
            };

            this.cardNumber = elements.create("cardNumber", {
                style: {},
                classes: elementClasses,
            });
            this.cardNumber.mount("#example2-card-number");

            let cardExpiry = elements.create("cardExpiry", {
                style: {},
                classes: elementClasses,
            });
            cardExpiry.mount("#example2-card-expiry");

            let cardCvc = elements.create("cardCvc", {
                style: {},
                classes: elementClasses,
            });
            cardCvc.mount("#example2-card-cvc");

            this.cardNumber.on("change", (event) => {
                this.card.brand = event.brand;
                this.$scope.$apply();
            });
        }

        confirm(card) {
            this.plan.loading = true;
            this.card.created = false;
            this.error = "";

            if (this.charge == false) {
                this.stripe
                    .handleCardSetup(this.plan.intent, this.cardNumber, {
                        payment_method_data: {
                            billing_details: {
                                name: card.holder_name,
                            },
                        },
                    })
                    .then((result) => {
                        if (result.error) {
                            this.handleStripeErrorResponse(result.error);
                        } else {
                            this.handleStripeResponse(
                                result,
                                result.setupIntent.payment_method
                            );
                        }
                    });
            } else {
                this.stripe
                    .handleCardPayment(this.plan.intent, this.cardNumber, {
                        payment_method_data: {
                            billing_details: {
                                name: card.holder_name,
                            },
                        },
                    })
                    .then((result) => {
                        if (result.error) {
                            this.handleStripeErrorResponse(result.error);
                        } else {
                            this.handleStripeResponse(
                                result,
                                result.paymentIntent.payment_method
                            );
                        }
                    });
            }
        }

        handleStripeResponse(result, payment_method) {
            this.card.created = true;
            if (this.conversionType == "signup") {
                this.close({ card: this.card, payment_method: payment_method });
            } else {
                this.subscriptionDataProvider
                    .paymentMethod(
                        payment_method,
                        this.conversionType == "change"
                    )
                    .then(() => this.close({ card: this.card }));
            }
        }

        handleStripeErrorResponse(error) {
            this.card.created = false;
            this.plan.loading = false;
            this.error = error.message;
            this.$scope.$apply();
        }
    },
};

angular
    .module("campaignplan")
    .component(PaymentFormComponent.selector, PaymentFormComponent);
